var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactInfoFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: "86mm",
    height: "21mm",
    viewBox: "0 0 86 21",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("text", {
    style: {
      fontSize: "8.46667px",
      lineHeight: 1.25,
      fontFamily: "JejuGothic",
      InkscapeFontSpecification: "JejuGothic",
      strokeWidth: 0.264583
    },
    x: 43.143009,
    y: 7.5620656,
    id: "text835"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan833",
    x: 43.143009,
    y: 7.5620656,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "8.46667px",
      fontFamily: "'Noto Sans CJK KR'",
      InkscapeFontSpecification: "'Noto Sans CJK KR'",
      textAlign: "center",
      textAnchor: "middle",
      strokeWidth: 0.264583
    }
  }, "\xA9 Mausfab 2021"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1409",
    x: 43.143009,
    y: 18.822737,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "8.46667px",
      fontFamily: "'Noto Sans CJK KR'",
      InkscapeFontSpecification: "'Noto Sans CJK KR'",
      textAlign: "center",
      textAnchor: "middle",
      strokeWidth: 0.264583
    }
  }, "ears@mausfab.com"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactInfoFooter);
export default __webpack_public_path__ + "static/media/contact_info_footer.f02258056154f1200def821129ef5a34.svg";
export { ForwardRef as ReactComponent };